import * as types from './mutation-types'
let defaultObject = () => ({
  data: {}
})

export default {
  [types.SET_PUBLIC_QUESTION] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.publicQuestion = payload
  },
  [types.SET_PUBLIC_QUESTIONS] (state, payload) {
    state.publicQuestions = payload.data
    state.pagination = payload.meta.pagination
  }
}
